'use strict';

module.exports = function() {
    var $consentTracking = $('#ConsentTracking');

    if (!$consentTracking || $('.consented').length) {
        $consentTracking.hide();
        return;
    }

    $consentTracking.find('.button-wrapper button').click(function (e) {
        e.preventDefault();
        var url = $(this).data('url');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function () {
                $consentTracking.remove();
            },
            error: function () {
                $consentTracking.remove();
            }
        });
    });
}
